import { BiAnswer, BiAnswerAction } from '@euler/model/bi/answer';
import { useCallback } from 'react';
import { BiDashboardToast } from './useBiDashboard';

/**
 * The toast's undo: a change made from the chat is undone in the chat, so
 * the conversation knows (and it waits while a reply runs); any other
 * change through the dashboard's own undo.
 */
export function useBiChatUndo({
  dashboardId,
  toast,
  chatBusy,
  answer,
  undo,
}: {
  dashboardId: string;
  toast: BiDashboardToast | null;
  chatBusy: boolean;
  answer: (value: BiAnswer) => boolean;
  undo: () => Promise<void>;
}) {
  const byChat =
    toast?.kind === 'chat_applied' || toast?.kind === 'chat_undone';
  const onUndo = useCallback(() => {
    // Undoing a chat undo redoes, in the chat too.
    if (toast?.kind !== 'chat_applied' && toast?.kind !== 'chat_undone') {
      void undo();
      return;
    }
    answer({
      action: BiAnswerAction.Undo,
      dashboardId,
      revision: toast.revision,
    });
  }, [toast, answer, dashboardId, undo]);
  return { onUndo, canUndo: !byChat || !chatBusy };
}
